import React, { FC, PropsWithChildren } from "react";

import { unitPageLayoutContentSidebar } from "@components/UnitPageLayout/styles";

const Sidebar: FC<PropsWithChildren> = ({ children }) => (
  <div css={unitPageLayoutContentSidebar}>{children}</div>
);

export default Sidebar;
